import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import TubingCalc from "./pages/TubingCalc";

// AppRoutes Component
function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/tubing" replace />} />
      <Route path="/tubing" element={<TubingCalc />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
